import User from '@/models/User';
import { Model } from './Model';

export type StudentAssessment = Model & {
  pedagogicalSheetId: number;
  behaviorAssessment: BehaviorAssessment;
  commentAssessment: CommentAssessment;
  occurrenceAssessment: OccurrenceAssessment;
  author: User;
  klassId: number;
};

export type BehaviorAssessment = Model & {
  attention: BehaviorRatingEnum;
  organization: BehaviorRatingEnum;
  initiative: BehaviorRatingEnum;
  socialization: BehaviorRatingEnum;
  apprenticeship: BehaviorRatingEnum;
  studentAssessmentId: number;
};

export type CommentAssessment = Model & {
  comment: string;
  studentAssessmentId: number;
};

export type OccurrenceAssessment = Model & {
  description: string;
  notificable: boolean;
  studentAssessmentId: number;
  scheduledLessonId: number | null;
};

export enum BehaviorRatingEnum {
  ONE = 1,
  TWO,
  THREE,
  FOUR,
  FIVE,
}
